import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const SERVICE_BY_ID_REQUEST = 'sherrinford/service/edit/SERVICE_BY_ID_REQUEST'
export const SERVICE_BY_ID_SUCCESS = 'sherrinford/service/edit/SERVICE_BY_ID_SUCCESS'
export const SERVICE_BY_ID_ERROR = 'sherrinford/service/edit/SERVICE_BY_ID_ERROR'

export const INPUT_SERVICE_REQUEST = 'sherrinford/service/edit/INPUT_SERVICE_REQUEST'
export const INPUT_SERVICE_SUCCESS = 'sherrinford/service/edit/INPUT_SERVICE_SUCCESS'
export const INPUT_SERVICE_ERROR = 'sherrinford/service/edit/INPUT_SERVICE_ERROR'

export const IS_LOADING = 'sherrinford/service/edit/IS_LOADING'
export const DATA = 'sherrinford/service/edit/DATA'

const initialState = {
  data: {
    id: '',
    productType: '',
    name: '',
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
}

export default createReducer(initialState, {
  [SERVICE_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [SERVICE_BY_ID_SUCCESS]: (state, data) => {
    const { id, productType, name } = data

    return {
      ...state,
      data: {
        id,
        productType: productType.id,
        name,
      },
      isLoading: false,
    }
  },
  [SERVICE_BY_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [INPUT_SERVICE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [INPUT_SERVICE_SUCCESS]: (state, data) => {
    const { id, productType, name } = data
    return {
      ...state,
      data: {
        id,
        productType: productType.id,
        name,
      },
      isLoading: false,
    }
  },
  [INPUT_SERVICE_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, service) => {
    const { data } = service
    return {
      ...state,
      data,
    }
  },
})

export const updateService = (data, id, cb) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      INPUT_SERVICE_REQUEST,
      INPUT_SERVICE_SUCCESS,
      INPUT_SERVICE_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/service/${id}`,
      payloads: data,
      authorization: `${token}`,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const getServiceById = (id) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      SERVICE_BY_ID_REQUEST,
      SERVICE_BY_ID_SUCCESS,
      SERVICE_BY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/service/${id}`,
      authorization: `${token}`,
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})
